import { Button, Modal, Form, InputNumber, Input, message } from "antd";
import UploadForm from "../../../../components/common/Uploads/uploadUtils";
import React, { useState } from "react";
import { createFile } from "../../../../utils/api";

function UploadImg(props) {
  const [form] = Form.useForm();
  const handleOk = async () => {
    let fieldValue = form.getFieldValue();
    let opt = JSON.parse(JSON.stringify(fieldValue));
    if (fieldValue.pictureOrder && fieldValue.content) {
      // 判断用户信息是否存在
      if (!props.userLoginInfo) {
        message.error("请先登录");
        this.props.history.push({ pathname: "/login" });
      } else {
        opt.type = "1";
        opt.createUser = props.userLoginInfo.username;
        let data = await createFile(opt);
        if (data?.code == 0) {
          message.success("创建成功");
          handleCancel();
        } else {
          message.error(data?.message);
        }
      }
    } else {
      message.error("请输入完整");
    }
  };
  const fileUrl = (imgArr) => {
    form.setFieldsValue({ content: imgArr.toString() });
  };
  const handleCancel = () => {
    form.resetFields();
    props.handleCancel();
  };
  return (
    <Modal
      title={`${props.uploadType}图片`}
      open={props.uploadVisible}
      onOk={handleOk}
      onCancel={handleCancel}
    >
      <Form form={form} labelCol={{ span: 4 }} wrapperCol={{ span: 14 }}>
        <Form.Item
          label="图片名称"
          name="name"
          rules={[{ required: true, message: "请填写图片名" }]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          label="顺序"
          name="pictureOrder"
          rules={[{ required: true, message: "请填写顺序" }]}
        >
          <InputNumber />
        </Form.Item>
        <Form.Item
          label="图片上传"
          name="content"
          rules={[{ required: true, message: "请上传图片" }]}
        >
          {/* <p style={{color:'rgba(0,0,0,.25)'}}>
            
          </p> */}
          <UploadForm
            fileUrl={fileUrl}
            uploadData={{ width: 1900, height: 600 }}
          />
        </Form.Item>
      </Form>
    </Modal>
  );
}
export default UploadImg;
